import React from 'react';
import Lottie from 'react-lottie';
import animation_preloder from './Animation/animation_preloder.json';
import ThemedLottie from 'app/Components/Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from 'app/utilities/theme/ThemeColorEnum';
import spinnerSvg from './Animation/spinner.svg';
import checkmarkSvg from './Animation/checkmark.svg';
import './checkFiberStatus.scss';

const SpinnerIcon = spinnerSvg.React;
const CheckmarkIcon = checkmarkSvg.React;

const STATUS_ROWS = [
  'מאתרים את התשתית באיזור',
  'מאתרים את התשתית ברחוב שלך',
  'מאתרים את התשתית לפי מספר הבית שלך',
];

const CheckFiberStatus = () => {
  return (
    <div className='check-fiber-status'>
      <ThemedLottie
        color={ThemeColorEnum.PRIMARY}
        animationData={animation_preloder}
        height={250}
        width={250}
        loop={true}
        autoplay={true}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
      />
      {STATUS_ROWS.map((text) => (
        <div className='animation-row' key={text}>
          <div className='spin-and-check'>
            <SpinnerIcon className='spin-and-check__spinner' aria-hidden='true' />
            <CheckmarkIcon className='spin-and-check__check' aria-hidden='true' />
          </div>
          <div className='text'>{text}</div>
        </div>
      ))}
      <p className='simple-text'>בעוד כמה רגעים נקבל תשובה!</p>
    </div>
  );
};

export default CheckFiberStatus;
